import { render } from "./StudentViewDemerits.vue?vue&type=template&id=40ba3c27"
import script from "./StudentViewDemerits.vue?vue&type=script&lang=js"
export * from "./StudentViewDemerits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__